import * as React from 'react';
import { useEffect, useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, FormControl, Grid, IconButton, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';

const CloseBtnRoot = styled('div')`
  position: absolute;
  right: 10px;
  top: 10px;
`;

const Root = styled('div')`
  padding: 20px 40px 0;
  position: relative;
`;

const TitleDialog = styled(DialogTitle)`
  position: relative;
  padding-top: 0;

  &:after {
    content: ' ';
    background-color: #ccc;
    width: calc(100% + 80px);
    height: 1px;
    position: absolute;
    left: -40px;
    bottom: 10px;
  }
`;

const Title = styled('div')`
  font-weight: bold;
  margin: 24px 0 0 0;
  color: black;
`;

export const EditVideoDialog = ({ onSave, open, handleClose, videoTitle }) => {
  const [title, setTitle] = useState<string>(videoTitle);
  const [valid, setValid] = useState<boolean>(false);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [touched, setTouched] = useState<boolean>(false);

  useEffect(() => {
    if (!touched) {
      setValid(false);
      return
    }

    if (videoTitle === title) {
      setErrors({ title: 'Title is still the same' });
      setValid(false);
    } else if (title.length === 0) {
      setErrors({ title: 'Title can not be empty' });
      setValid(false);
    } else {
      setErrors({});
      setValid(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth={'sm'}>
      <Root>
        <CloseBtnRoot>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </CloseBtnRoot>
        <TitleDialog>
          <Title>{`Edit video title`}</Title>
        </TitleDialog>
        <DialogContent>
          <Grid container spacing={2} style={{ marginTop: 0 }}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <TextField
                  id="title"
                  multiline
                  rows={2}
                  autoFocus
                  label="Video title"
                  variant="outlined"
                  type={'text'}
                  onChange={(e) => {
                    setTitle(e.target.value)
                  }}
                  onFocus={() => setTouched(true)}
                  value={title}
                  error={Boolean(errors.title)}
                  helperText={errors.title}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Grid container justifyContent={'flex-end'}>
                <Button color="primary" variant="contained" disabled={!valid} onClick={() => onSave(title)}>
                  Save
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Root>
    </Dialog>
  );
};
